/* eslint-disable import/prefer-default-export */
import { takeLatest, put, call, all } from 'redux-saga/effects' // eslint-disable-line
import getRegionalProjectActions, {
    getRegionalProjectTypes,
} from '../../../../redux/donneesSocioEconomique/donneesRegionalProject/getRegionalProject'
import { Get } from '../../../../serveur/axios'

function* getRegionalProjectSagas() {
    try {
        const res = yield Get(`regional-project-filtre`)

        if (res.status === 200) {
            yield all([
                yield put(
                    getRegionalProjectActions.getRegionalProjectSuccess(res)
                ),
            ])
        } else {
            yield put(getRegionalProjectActions.getRegionalProjectFailure(res))
        }
    } catch (error) {
        yield put(getRegionalProjectActions.getRegionalProjectFailure(error))
    }
}

export function* getRegionalProjectSaga() {
    yield takeLatest(
        getRegionalProjectTypes.GET_REGIONAL_PROJECT_REQUEST,
        getRegionalProjectSagas
    )
}
